<sb-card *ngIf="(!loading && screens?.length === 0) || loading">
  <div card-body [classes]="'d-flex align-items-center justify-content-center'">
    <h4 *ngIf="!loading && screens?.length === 0">
      {{ 'lang.globals.noData'|translate }}
    </h4>
    <sb-loading-spinner *ngIf="loading"></sb-loading-spinner>
  </div>
</sb-card>

<sb-card *ngIf="screens">
  <div card-body>
    <table class="table">
      <thead>
      <tr>
        <th>ID</th>
        <th>Name</th>
        <th>{{ 'lang.admin.device.machineCode' |translate }}</th>
        <th>{{ 'nav.network.mediumTransformations' |translate }}</th>
        <th>{{ 'lang.globals.screenHardware' |translate }}</th>
        <th>
          <div class="tw-flex tw-justify-end">
            <button *ngPermissions="permissionService.Permission.device_playlist_cache_delete"
                    sb-button-primary [icon]="'trash'" type="button" color="red" size="large" (click)="deleteDevicePlaylistCache()">
              {{ 'lang.globals.deleteDevicePlaylistCache'|translate }}
            </button>
          </div>
        </th>
      </tr>
      </thead>
      <tbody>
        @for (screen of screens; track screen.id) {
        <tr>
          <td>{{ screen.id }}</td>
          <td>{{ screen.name }}</td>
          <td>{{ screen.machineCode }}</td>
          <td>{{ screen.mediumTransformation?.name }}</td>
          <td>{{ screen.hardware?.name }}</td>
          <td class="tr">
            <ng-container *ngPermissions="permissionService.Permission.medium_transformation_list">

              <button class="btn btn-primary mr-2" (click)="addMediumTransformation(screen)"
                      ngbTooltip="{{'lang.globals.mediumTransformation'| translate}}"
              >
                <sb-icon icon="expand"></sb-icon>
              </button>
              <button
                class="btn btn-danger mr-2"
                *ngIf="screen.mediumTransformation"
                (click)="removeMediumTransformation(screen)"
                ngbTooltip="{{'lang.globals.removeMediumTransformation'| translate}}"
              >
                <sb-icon icon="trash"></sb-icon>
              </button>
            </ng-container>
            <ng-container *ngPermissions="permissionService.Permission.screen_hardware_list">

              <button class="btn btn-primary mr-2" (click)="addScreenHardware(screen)"
                      ngbTooltip="{{'lang.globals.screenHardware'| translate}}"
              >
                <sb-icon icon="screenSetting"></sb-icon>
              </button>
              <button
                class="btn btn-danger mr-2"
                *ngIf="screen.hardware"
                (click)="removeScreenHardware(screen)"
                ngbTooltip="{{'lang.device.screenHardware.delete'| translate}}"
              >
                <sb-icon icon="trash"></sb-icon>
              </button>
            </ng-container>
            <button class="btn btn-primary mr-2" (click)="showRenderedTemplateEntries(screen)"
                    ngbTooltip="{{'nav.templateEntries' | translate}}"
            >
              <sb-icon icon="templateEntry"></sb-icon>
              <sb-icon *ngIf="!screen.renderedTemplates" icon="chevronDown" class="ml-1 icon-in-btn"></sb-icon>
              <sb-icon *ngIf="screen.renderedTemplates" icon="chevronUp" class="ml-1 icon-in-btn"></sb-icon>
            </button>
            <button class="btn btn-primary" (click)="changePlaylistVisible(screen)"
                    ngbTooltip="Playlist"
            >
              <sb-icon icon="schedules"></sb-icon>
              <sb-icon *ngIf="!screen.playlistVisible" icon="chevronDown" class="ml-1 icon-in-btn"></sb-icon>
              <sb-icon *ngIf="screen.playlistVisible" icon="chevronUp" class="ml-1 icon-in-btn"></sb-icon>
            </button>
          </td>
        </tr>
        <tr *ngIf="screen?.playlistVisible">
          <td colspan="100">
            <sb-card *ngIf="(!playlistLoading && !screenPlaylist) || playlistLoading">
              <div card-body [classes]="'d-flex align-items-center justify-content-center'">
                <h4 *ngIf="!playlistLoading && !screenPlaylist">
                  {{ 'lang.globals.noData'|translate }}
                </h4>
                <sb-loading-spinner *ngIf="playlistLoading"></sb-loading-spinner>
              </div>
            </sb-card>
            <sb-card *ngIf="screenPlaylist">
              <div card-body>
                <div class="row">
                  <div class="col-7">
                    <div class="">
                      <div class="">ID: {{ screenPlaylist?.id }}</div>
                      <div class="">Identifier: <span [innerHTML]="screenPlaylist?.identifier | truncate: 100"></span></div>
                      <div class="">Last Access: {{ screenPlaylist?.lastAccess?.toString() | date: 'dd.MM.yy HH:mm:ss' }}</div>
                      <div class="tw-flex tw-items-center">{{ 'lang.deviceDetails.productive'|translate }}:
                        <sb-icon *ngIf="screenPlaylist?.productive" icon="success" class="green"></sb-icon>
                        <sb-icon *ngIf="!screenPlaylist?.productive" icon="error" class="red"></sb-icon>
                      </div>
                      <div class="">{{ 'lang.globals.map.position'|translate }}:
                        <a *ngIf="screenPlaylist?.position"
                           [sbMapTooltip]="{type: 'Coordinates', data: { x: screenPlaylist.position.coordinates[0], y: screenPlaylist.position.coordinates[1] }}"
                           class="link"
                           container="body"
                           ngbTooltip [openDelay]="300" placement="right left" tooltipClass="widthFix">
                          <sb-icon class="mr-2" icon="location"></sb-icon>
                          {{ screenPlaylist.position.coordinates[1] }}
                          -
                          {{ screenPlaylist.position.coordinates[0] }}
                        </a>
                      </div>
                      <div *ngIf="screenPlaylist?.validity" class="">
                        {{ 'lang.globals.validity'|translate }}:
                        <div class="border-dashed-bottom d-inline-block" container="body"
                             [ngbTooltip]="util.calculateTimespanBetweenDates(screenPlaylist?.validity?.from, screenPlaylist?.validity?.till)"
                        >
                          {{ util.dateToDateTimeString(screenPlaylist?.validity?.from?.value) }}
                          -  {{ util.dateToDateTimeString(screenPlaylist?.validity?.till?.value) }}
                        </div>
                        <a *ngIf="screenPlaylist?.geoValidity"
                           [sbMapTooltip]="{type: 'Polygon', data: [screenPlaylist.geoValidity]}"
                           class="link"
                           container="body"
                           ngbTooltip [openDelay]="300" placement="right left" tooltipClass="widthFix">
                          <sb-icon class="mr-2" icon="location"></sb-icon>
                          {{ 'lang.cull.area'|translate }}
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-5">
                    <button *ngPermissions="permissionService.Permission.device_playlist_cache_delete"
                            sb-button-primary [icon]="'trash'" type="button" color="red" size="large"
                            (click)="deleteScreenPlaylistCache(screen)">
                      {{ 'lang.globals.deleteScreenPlaylistCache'|translate }}
                    </button>
                    <button class="btn btn-primary ml-2" (click)="openScreenPlaylistScheme(screenPlaylist)">
                      {{ 'lang.globals.playlistScheme'|translate }}
                    </button>
                    <button class="btn btn-primary ml-2" (click)="refreshPlaylist(screen.id)">
                      <sb-icon icon="refresh"></sb-icon>
                    </button>
                  </div>
                </div>
                <div class="row ">
                  <div class="col">
                    @for (iteration of screenPlaylist?.renderedIterations; track $index) {
                      <div>
                      <sb-card>
                        <div card-body>
                          <ng-scrollbar [track]="'horizontal'" [autoHeightDisabled]="false">
                            <table class="table">
                              <thead>
                              <tr>
                                <th>Slot</th>
                                <th>{{ 'lang.globals.duration'|translate }}</th>
                                <th>{{ 'lang.globals.booking'|translate }}</th>
                                <th>{{ 'lang.globals.advertiser'|translate }}</th>
                                <th>{{ 'lang.globals.delivered'|translate }}</th>
                                <th>{{ 'lang.globals.played'|translate }}</th>
                              </tr>
                              </thead>
                              <tbody>
                                @for (slot of iteration?.slots; track slot.index) {
                                  <tr>
                                <td>
                                  Slot {{ slot?.slot + 1 }}
                                </td>
                                <td>
                                  {{ slot?.duration }}s
                                </td>
                                <td>
                                  <sb-comp-image-name-wrapper
                                    [medium]="getMediumForSlot(screenPlaylist, slot)"
                                    [still]="true"
                                    [hoverPreview]="true">
                                    <span firstLine [innerHTML]="getMediumForSlot(screenPlaylist, slot)?.name | truncate:25"></span>
                                    <span secondLine
                                          *ngIf="getBookingForSlot(screenPlaylist, slot)?.templateDataSet"> {{ 'lang.globals.templateDataset'|translate }}
                                      :
                            <span
                              [innerHTML]="getBookingForSlot(screenPlaylist, slot)?.templateDataSet?.name | truncate:25">
                            </span>
                            </span>
                                    <span thirdLine
                                          *ngIf="getBookingForSlot(screenPlaylist, slot)?.templateDataSetEntry"> {{ 'lang.globals.templateDatasetEntry'|translate }}
                                      :
                            <span
                              [innerHTML]="getBookingForSlot(screenPlaylist, slot)?.templateDataSetEntry?.name | truncate:25">
                            </span>
                          </span>
                                  </sb-comp-image-name-wrapper>
                                </td>
                                <td>
                                  <sb-comp-image-name-wrapper [image]="getBookingForSlot(screenPlaylist,slot)?.advertiser?.logo?.url">
                                      <span [innerHTML]="getBookingForSlot(screenPlaylist,slot)?.advertiser?.name | truncate : 25"
                                            firstLine></span>
                                  </sb-comp-image-name-wrapper>
                                </td>
                                <td>
                                  <sb-icon *ngIf="slot?.delivered" icon="success" class="green"></sb-icon>
                                  <sb-icon *ngIf="!slot?.delivered" icon="error" class="red"></sb-icon>
                                </td>
                                <td>
                                  <sb-icon *ngIf="slot?.played" icon="success" class="green"></sb-icon>
                                  <sb-icon *ngIf="!slot?.played" icon="error" class="red"></sb-icon>
                                </td>

                              </tr>
                                }
                              </tbody>
                            </table>
                          </ng-scrollbar>
                        </div>
                      </sb-card>
                    </div>
                    }
                  </div>
                </div>
              </div>
            </sb-card>

          </td>
        </tr>
        <tr *ngIf="screen.renderedTemplates">
          <td colspan="100">
            <sb-comp-rendered-groups [screen]="screen">

            </sb-comp-rendered-groups>
          </td>
        </tr>
        }
      </tbody>
    </table>
  </div>
</sb-card>
